import React from 'react'
import { Link } from 'react-router-dom'
import uuid from 'uuid/v1'
import AreaTitle from './AreaTitle';

class PromoArea extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      cards : [{
        idx: 'honesty',
        title: 'Honestidad',
        text: 'Somos un grupo de profesionales que trabajamos con verdad y transparencia.',
        isFlipped: false
      },
      {
        idx: 'ethic',
        title: 'Ética',
        text: 'Toda acción que llevamos a cabo es bajo una fuerte ética profesional. Lo creemos muy importante para crecer sostenidamente en el tiempo.',
        isFlipped: false
      },
      {
        idx: 'professionalism',
        title: 'Profesionalismo',
        text: 'Somos formados en el rubro comercio exterior, adaptandonos a todas las normativas que fueron cambiando en los últimos 25 años en Argentina.',
        isFlipped: false
      },
      {
        idx: 'fidelity',
        title: 'Fidelidad',
        text: 'Nos caracterizamos por el cumplimiento de los compromisos establecidos en pos de los objetivos a cumplir.',
        isFlipped: false
      }]
    }
  }

  flipCard = (index) => {
    let newCards = this.state.cards.map((c) => {
      if(c.idx === index) {
        c.isFlipped = !c.isFlipped
      }
      return c
    })
    this.setState({ cards: newCards })
  }

  componentDidMount() {
    let $ = window.$
    this.state.cards.forEach((c) => {
      const id = `#${c.idx}`
      $(id).on('click', (evt) => {
        $(id).on('animationend', () => $(id).removeClass('animated flipInY'))
        if(!$(id).hasClass('animated')) {
          $(id).addClass('animated flipInY')
          console.log($(id))
        }else{
          evt.stopPropagation()
        }
      })
    })
  }

  render() {
    return (<section className="promo-area" id="about-link">
    <div className="promo-bottom-area section-padding">
        <div className="promo-botton-area-bg" data-stellar-background-ratio="0.6"></div>
        <div className="container">
            <div className="row">
                <div className="col-md-10 col-lg-10 col-md-offset-1 col-lg-offset-1 col-sm-12 col-xs-12 text-center">
                    <div className="promo-bottom-content wow fadeIn">
                        <AreaTitle title="A cerca de nosotros">
                        <p style={{color: 'white', marginTop: 45 }}>
                        Somos un grupo de profesionales con más de 25 años de experiencia en comercio exterior. Con nuestra experiencia en comercio exterior nos ha permitido comprender los pilares de una empresa confiable. Son los valores esenciales de sus integrantes, junto con una constante y dinámica política de capacitación los que llevan al éxito comercial. Mediante los conceptos detallados a continuación logramos resolver de manera eficiente las distintas variables y en diferentes contextos políticos económicos todas las operaciones de comercio exterior.
                        </p>
                        </AreaTitle>
                        
                        <div className="row" style={{ marginTop: 45 }}>
                          <div id="tcc-cards-area">
                            {
                              this.state.cards.map((c) => (
                                <div id={c.idx} onClick={ () => this.flipCard(c.idx) } className="tcc-card">
                                { c.isFlipped ? <div>{c.text}</div> : <div style={{ fontSize: 15 }}>{c.title}</div>}                            
                              </div>))
                            }
                          </div>
                        </div>
                        <Link to="/contacto" style={{margin: '65px auto 0'}} className="tcc-contact-button">Contáctenos</Link>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </section>)
  }
}

export default PromoArea